import React from "react";
import { infoiconorange } from "../svgs/svgcode";


const UnsavedChangesModal = ({
  open,
  title = "",
  message = "",
  confirmText = "",
  cancelText = "",
  onConfirm,
  onCancel,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/40">
      <div className="relative w-full max-w-sm rounded-xl bg-white shadow-xl">
        
        {/* Close icon */}
        <button
          onClick={onCancel}
          className="absolute right-4 top-4 text-gray-400  hover:text-gray-600"
        >
          ✕
        </button>

        {/* Icon */}
        <div className="flex justify-center mb-4 mt-4">
          <div className="bg-[#FFEDD5] flex items-center justify-center w-12 h-12 rounded-full">
            {infoiconorange}
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center text-lg  font-semibold text-gray-900 mb-4">
          {title}
        </h2>

      

        {/* Actions */}
        <div className="flex justify-center gap-3 bg-[#F9FAFB] p-6 ">
<button
  onClick={onCancel}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#F97316";
    e.currentTarget.style.color = "#ffffff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#ffffff";
    e.currentTarget.style.color = "#374151"; // text-gray-700
  }}
  style={{
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    padding: "8px 16px",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
  }}
>
  {cancelText}
</button>

<button
  onClick={onConfirm}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#ea6a10";
    e.currentTarget.style.color = "#ffffff";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#ffffff";
    e.currentTarget.style.color = "#374151";
  }}
  style={{
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    padding: "8px 16px",
    borderRadius: "6px",
    fontSize: "14px",
    cursor: "pointer",
  }}
>
  {confirmText}
</button>


        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
